export default {
  development: 'http://localhost:3080',
  production: 'https://mbe.qmkey.com/backend',
};
